import BaseComponent from '@/components/base';
import { convertCamelCaseToWords } from '@/utils';
import { buttonsLayoutStyle } from '@/components/mini-quiz/buttons-layout/style';

export default class ButtonsLayout extends BaseComponent {
  render() {
    this.selectedButtons = [];
    return `
    ${this.componentStyle}

    <div class="title">
        ${this.title}
    </div>
    <div class="options-container">
    ${this.options
      .map(
        (option) =>
          `
            <button value="${option.dataKey}">
              <img src="${option.image}">
              <div class="text">${option.name}</div>
            </button>`
      )
      .join('')}
    </div>
    <span class="error-message">Oops! You didn't select the ${
      this.data?.config?.value?.keyName || 'hair goals'
    }.</span>
    `;
  }

  afterMount() {
    this.shadowRoot
      .querySelectorAll('button')
      .forEach((button) =>
        button.addEventListener('click', () => this.handleButtonClick(button))
      );
  }

  handleButtonClick(button) {
    const buttonName = button.textContent;
    const quantityToSelect =
      Number(this.data?.config?.value?.quantityToSelect) || 5;

    if (this.selectedButtons.includes(buttonName)) {
      this.selectedButtons = this.selectedButtons.filter(
        (name) => name !== buttonName
      );
      button.classList.remove('selected');
    } else {
      if (this.selectedButtons.length >= quantityToSelect) {
        const firstSelectedButtonName = this.selectedButtons.shift();
        const firstSelectedButton = Array.from(
          this.shadowRoot.querySelectorAll('button')
        ).find((btn) => btn.textContent === firstSelectedButtonName);
        firstSelectedButton.classList.remove('selected');
      }
      this.selectedButtons.push(buttonName);
      button.classList.add('selected');
    }

    this.updateSelectedList();
  }

  updateSelectedList() {
    const selectedButtons = Array.from(
      this.shadowRoot.querySelectorAll('button.selected')
    );
    const values = selectedButtons.map((x) => x.value);

    this.selectedValue = values;

    this.dispatchEvent(
      new CustomEvent('buttonsChange', {
        detail: { value: values },
        bubbles: true,
        composed: true
      })
    );
  }

  showErrorMessage() {
    this.shadowRoot
      .querySelector('.error-message')
      .classList.toggle('show', true);
  }

  hideErrorMessage() {
    this.shadowRoot
      .querySelector('.error-message')
      .classList.toggle('show', false);
  }

  get componentStyle() {
    return buttonsLayoutStyle;
  }
  get title() {
    return `${convertCamelCaseToWords(this.data?.config?.value?.keyName)}
        (select up to
            ${this.data?.config?.value?.quantityToSelect || 5}
        )`;
  }

  get options() {
    if (this.data?.options?.value?.length > 0) {
      return this.data.options.value;
    }
  }

  get images() {
    return this.data.images.value;
  }

  get selectedValue() {
    return JSON.parse(this.getAttribute('value'));
  }

  set selectedValue(values) {
    this.setAttribute('value', JSON.stringify(values));
  }
}
